export const CARD_STATUS_ENUMS = {
  0: 'dark',
  1: 'open',
  2: 'expired',
  3: 'upcoming',
};
export const DARK_CARD_STATUS = 0;
export const OPENED_CARD_STATUS = 1;
export const MAX_CARDS_COUNT = 417;
export const CARD_IMG_MAX_WIDTH_BY_PX = 244;
export const CARD_IMG_MIN_WIDTH_BY_PX = 176;
export const CARD_IMG_MAX_WIDTH_BY_REMS = 18.1;
export const CARD_IMG_MIN_WIDTH_BY_REMS = 14.9;
export const USER_CARD_ANIMATION_DURATION = 2.1;
export const DEALER_CARD = 1;
